<!--数据字典-->
<template>
  <div class="app_container" :class="{ 'list-drag': dragaable }">
    <!--操作栏-->
    <div class="filter_container">
      <!-- <butn
        v-permission="'category:save'"
        btntype="primary"
        title="新增"
        @click="handleAdd"
        iconName="el-icon-plus"
      ></butn> -->
      <el-checkbox v-model="dragaable" class="drag-box">拖拽排序</el-checkbox>
    </div>
    <el-tree-table
      ref="pageListTable"
      headerRowClassName="RCTableHeader"
      cellClassName="RCTableCell"
      :column-custom-render="columnCustomRender"
      :treeData="feedbackTree"
      :columns="columns"
      :columnSelectionWidth="0"
      :expand-indexes="expandIndexes"
    >
    </el-tree-table>
    <!-- <Tables :data="feedbackTree" /> -->
    <!-- 新增、编辑 -->
    <Curd />
  </div>
</template>
<script>
import "@/components/list/table.css";
// import butn from "@/components/button/index";
import Bus from "./Bus.js";
import ElTreeTable from "@panhezeng/el-tree-table";
import Curd from "./curd";
import Sortable from "sortablejs";
import {
  resCategoryDelete,
  resCategorySH,
  resCategoryTree,
  resCategoryDrag,
} from "@/api/rescategory";

const test1 = 1;
const test2 = 2;
const TestComp = {
  template: `
      <div>
        <slot/>
      </div>
      `,
};
export default {
  name: "rescategory",
  components: { Curd, ElTreeTable },
  data() {
    return {
      feedbackTree: [],
      expandIndexes: [],
      dragaable: false,
      flatParamList: [],
      columns: [
        {
          label: "资源分类",
          prop: "name",
          minWidth: "160",
        },
        {
          label: "分类简称",
          prop: "aliasName",
          minWidth: "160",
        },
        {
          label: "是否显示",
          prop: "typeName",
          minWidth: "150",
        },
        {
          label: "创建时间",
          prop: "createDate",
          minWidth: "150",
        },
        {
          label: "操作",
          prop: "action",
          fixed: "right",
          minWidth: "150",
        },
      ],
      columnCustomRender: {
        action: {
          props: {
            cellData: { invalidData: true },
            test1,
            test2,
            vm: this,
          },
          component: {
            components: { TestComp },
            props: {
              cellData: {
                type: Object,
                default() {
                  return {};
                },
              },
              vm: {
                type: Object,
                default() {
                  return {};
                },
              },
              test2: Number,
            },
            methods: {
              updateHandler() {
                Bus.$emit("updateRes", this.cellData.row.id);
              },
              delHandler() {
                this.vm.deleteRes(this.cellData.row);
              },
              handleChild() {
                Bus.$emit("addRes", this.cellData.row.id, "新增子类");
              },
              hideShowRes(status) {
                this.vm.hideShowRes(this.cellData.row.id, status);
              },
            },
            template: `
                      <test-comp>
                        <div class="deal-group">
                            <el-tooltip
                              effect="dark"
                              placement="top"
                              content="新增子类"
                              v-permission="'category:save'"
                              v-show="cellData.row.canAddChild"
                            >
                              <i class="icon-add" @click="handleChild"></i>
                            </el-tooltip>
                            <el-tooltip
                              effect="dark"
                              placement="top"
                              content="编辑"
                              v-permission="'category:update'"
                            >
                              <i class="icon-edit" @click="updateHandler"></i>
                            </el-tooltip>
                            <el-tooltip
                              effect="dark"
                              content="删除"
                              placement="top"
                              v-permission="'category:delete'"
                            >
                              <i class="icon-delete" @click="delHandler"></i>
                            </el-tooltip>
                            <el-tooltip
                              v-if="cellData.row.type == '1'"
                              effect="dark"
                              content="隐藏"
                              placement="top"
                              v-permission="'category:show'"
                            >
                              <i class="icon-hide" @click="hideShowRes(0)"></i>
                            </el-tooltip>
                            <el-tooltip
                              v-if="cellData.row.type !== '1'"
                              effect="dark"
                              content="显示"
                              placement="top"
                              v-permission="'category:show'"
                            >
                              <i class="icon-show" @click="hideShowRes(1)"></i>
                            </el-tooltip>
                        </div>
                      </test-comp>
                      `,
          },
        },
      },
    };
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
  methods: {
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",

          onEnd({ oldIndex, newIndex }) {
            let flagDept = true;
            const oldRow = _this.flatParamList[oldIndex];
            const newRow = _this.flatParamList[newIndex];
            if (oldRow.pid !== newRow.pid) {
              _this.$message({
                message: "不同分类下不能排序",
                type: "error",
              });
              flagDept = false;
              // // 列表刷新
              _this.$nextTick(() => {
                _this.initData();
              });
            }
            if (flagDept) {
              // const currRow = _this.flatParamList[oldIndex];
              let offset = newIndex - oldIndex;
              let params = {
                upOrDown: Number(offset) > 0 ? 1 : -1,
                dragUuid: oldRow.id,
                otherUuid: newRow.id,
              };
              resCategoryDrag(params).then((res) => {
                if (!res || res.code != 0) return;
                _this.$message({
                  message: "排序成功",
                  type: "success",
                });
                const currR = _this.flatParamList.splice(oldIndex, 1)[0];
                _this.flatParamList.splice(newIndex, 0, currR);
                _this.expandIndexes = _this.$refs.pageListTable
                  .getExpandRows()
                  .map((value) => value.treeFullIndex);
                let feedbackTree = _this.getTree(
                  _this.flatParamList[0].pid,
                  _this.flatParamList
                );
                _this.feedbackTree = JSON.parse(JSON.stringify(feedbackTree));
                _this.flatParamList = [];
                _this.getFlatParamList(_this.feedbackTree);
              });
            }
          },
        });
      }
    },
    // 将普通列表转换为树结构的列表
    getTree(parentId, list) {
      let data = [];
      for (const key in list) {
        if (list[key].pid == parentId) {
          let child = this.getTree(list[key].id, list);
          if (child.length > 0) {
            list[key].children = child;
          }
          data.push(list[key]);
        }
      }
      return data;
    },
    getFlatParamList(data) {
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.flatParamList.push(data[i]);
          let curData = data[i].children;
          if (curData && curData.length > 0) {
            this.getFlatParamList(curData);
          }
        }
      }
    },
    handleAdd() {
      Bus.$emit("addRes", 0, "新增资源分类");
    },
    initData() {
      resCategoryTree().then((res) => {
        this.feedbackTree = this.setLevel(res.data);
        this.flatParamList = [];
        this.getFlatParamList(this.feedbackTree);
      });
    },
    setLevel(arr) {
      if (!Array.isArray(arr)) return;
      let res = arr.map((x) => {
        let n = {
          children: [],
        };
        if (x.children && x.children.length > 0) {
          n.children = x.children.map((t) => {
            return { ...t, canAddChild: true };
          });
        }
        if (n.children.length > 0) {
          return { ...x, children: n.children, canAddChild: true };
        }
        return { ...x, canAddChild: true };
      });
      return res;
    },
    deleteRes(item) {
      let message;
      if (item.pid == 0 && item.children && item.children.length > 0) {
        message = "确认删除该资源类别吗？系统将一同删除该类别下的所有子类。";
      } else {
        message = "确认删除该资源类别吗?";
      }
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        resCategoryDelete({ uuids: [item.id] }).then((res) => {
          if (!res || res.code != 0) return;
          this.initData();
          this.$message.success(res.msg);
        });
      });
    },
    hideShowRes(id, status) {
      let message = status == 1 ? "显示" : "隐藏";
      this.$confirm(`确认${message}该资源类别吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        resCategorySH(id, status).then((res) => {
          if (!res || res.code != 0) return;
          this.initData();
          this.$message.success(res.msg);
        });
      });
    },
  },
  created() {
    this.initData();
    Bus.$on("initTable", () => {
      if (this.$refs.pageListTable) {
        this.expandIndexes = this.$refs.pageListTable
          .getExpandRows()
          .map((value) => value.treeFullIndex);
      }

      this.initData();
    });
  },
  beforeDestroy() {
    Bus.$off("initTable");
  },
};
</script>
<style lang="scss" scoped>
/deep/ .drag-box {
  margin-left: 16px;
}
</style>
